// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IGetNewbuildingsForDeveloperCardRequest,
  TGetNewbuildingsForDeveloperCardModel,
  IMappers,
  TGetNewbuildingsForDeveloperCardResponse,
  IGetNewbuildingsForDeveloperCardResponse,
  IGetNewbuildingsForDeveloperCardResponseError,
} from './types';

export const defaultConfig: TGetNewbuildingsForDeveloperCardModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'POST',
  microserviceName: 'newbuilding-search',
  pathApi: '/v1/get-newbuildings-for-developer-card/',
  requestType: 'json',
} as TGetNewbuildingsForDeveloperCardModel;

export function createGetNewbuildingsForDeveloperCardModel(
  parameters: IGetNewbuildingsForDeveloperCardRequest,
): TGetNewbuildingsForDeveloperCardModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetNewbuildingsForDeveloperCardOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetNewbuildingsForDeveloperCardRequest;
}

export async function fetchGetNewbuildingsForDeveloperCard<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetNewbuildingsForDeveloperCardOptions<TResponse200, TResponse400>): Promise<
  TGetNewbuildingsForDeveloperCardResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(
    createGetNewbuildingsForDeveloperCardModel(parameters),
    config,
  );
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetNewbuildingsForDeveloperCardResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IGetNewbuildingsForDeveloperCardResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TGetNewbuildingsForDeveloperCardResponse;
}
